import { PageNotFoundComponent } from './../page-not-found/page-not-found.component';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

  emailAddress = "";
  formChanged: boolean = false;
  headers = new Headers({ 'Content-Type': 'application/json', 'accept': 'application/json' });
  options = new RequestOptions({ headers: this.headers });
  user: any;

  constructor(private route: ActivatedRoute, private http: Http, private router: Router, private toastr: ToastsManager) { }

  userProfileForm = new FormGroup({
    name: new FormControl(''),
    surname: new FormControl(''),
    idNumber: new FormControl(''),
    cellphone: new FormControl(''),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8)]),
    submit: new FormControl()
  })

  ngOnInit() {
   this.getUserProfile();
   this.userProfileForm.valueChanges.subscribe(data => {
     if(this.userProfileForm.dirty) 
        this.formChanged = true;
    });
  }

  getUserProfile() {
    this.route.paramMap
    .subscribe(params => {
      this.emailAddress = params.get('email');
    });   

    this.http.post("http://localhost:8080/users/get", this.emailAddress, this.options)
    .subscribe(response => {

      this.name.setValue(response.json().name);
      this.surname.setValue(response.json().surname);
      this.email.setValue(response.json().emailAddress);
      this.idNumber.setValue(response.json().idNumber);
      this.cellphone.setValue(response.json().cellphone);
      this.password.setValue(response.json().password);
      this.confirmPassword.setValue(response.json().password);

      this.user = response.json();

      console.log(response.json());
    }, error => {
      this.toastr.error('An unexpected error occurred while fetching your details.', 'Oops!');
    });
  }

  updateUserProfile() {
    if (this.formChanged) {
      this.user.email = this.email.value;
      this.user.cellphone = this.cellphone.value;
      this.user.surname = this.surname.value;
      this.user.name = this.name.value;
      this.user.idNumber = this.idNumber.value;
      this.user.password = this.password.value;

      console.log("Attempting to update user");
      console.log(this.user);

      this.http.post("http://localhost:8080/users/update", JSON.stringify(this.user), this.options)
      .subscribe(response => {
        console.log(response.json());
      });
    }
    else {
      console.log("Profile is already up to date");
    }

    this.router.navigate(['home']);
  }

  get email() { return this.userProfileForm.get('email'); }
  get password() { return this.userProfileForm.get('password'); }
  get confirmPassword() { return this.userProfileForm.get('confirmPassword'); }
  get name() { return this.userProfileForm.get('name'); }
  get surname() { return this.userProfileForm.get('surname'); }
  get idNumber() { return this.userProfileForm.get('idNumber'); }
  get cellphone() { return this.userProfileForm.get('cellphone'); }

}



// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/user-profile/user-profile.component.ts